import "./App.css";
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ICast from "./screens/Icast";
import ContactForm from "./screens/Contact";
import VenuMap from "./screens/VenuMap";
import CallForContent from "./screens/CallForContent";
import Expositions from "./screens/Expositions";
import AimsPage from "./screens/Aims";
import Registration from "./screens/Registration";
import GovernancePage from "./screens/Governance";
import ThemePage from "./screens/Themes";
import ScreenInProgress from "./NoContent/NoContent";
import Genisis from "./screens/Genesis";
import ICAST2025 from "./screens/Icast2025";
import CallForPapers from "./screens/CallForPapers";
import CallForSessions from "./screens/CallForSessions";
import AuthorResources from "./screens/AuthorResources";
import Grants from "./screens/Grants";
import Press from "./screens/Press";
import SocialFeeds from "./screens/SocialFeeds";
import DownloadsSection from "./screens/DownloadSection";
import FeedbackForm from "./Components/FeedbackForm";
import ConferenceProgramPage from "./screens/ConferenceProgram";
import SpeakersPage from "./screens/ICASTDelegates";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<ICast />} />
          <Route path="/content" element={<CallForContent/>}/>
          <Route path="/expo" element={<Expositions/>}/>
          <Route path="/grants" element={<Grants/>}/>
          <Route path="/why-attend" element={<AimsPage/>}/>
          <Route path="/genisis" element={<Genisis/>}/>
          <Route path="/icast-2025" element={<ICAST2025/>}/>
          <Route path="/governance" element={<GovernancePage/>}/>
          <Route path="/call-for-papers" element={<CallForPapers/>}/>
          <Route path="/call-for-session" element={<CallForSessions/>}/>
          <Route path="/author-resources" element={<AuthorResources/>}/>
          <Route path="/registration" element={<Registration/>}/>
          <Route path="/icast-delegates" element={<SpeakersPage/>}/>
          <Route path="/tracks" element={<ThemePage/>}/>
          <Route path="/press-release" element={<Press/>}/>
          <Route path="/downloads" element={<DownloadsSection/>}/>
          <Route path="/conference-program" element={<ConferenceProgramPage/>}/>
          <Route path="/social-feeds" element={<SocialFeeds/>}/>
          <Route path="/contact" element={<ContactForm />} />
          <Route path="/map" element={<VenuMap />} />
          <Route path="/screen-inprogress" element={<ScreenInProgress />} />
          <Route path="/feedback" element={<FeedbackForm />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
